/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'covid-social-distancing-correct-2-stroke': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<desc>virus</desc><g stroke-linecap="round" stroke-width="1.5" _stroke="currentColor" _fill="none" stroke-linejoin="round"><path pid="0" d="M4.97 14.125a2.62 2.62 0 100 5.25 2.62 2.62 0 100-5.25zM9.2 23.125h0a4.482 4.482 0 00-8.46-.01M19.02 14.125a2.625 2.625 0 100 5.25 2.625 2.625 0 100-5.25zM23.25 23.125h0a4.482 4.482 0 00-8.46-.01M5 8.88v2M19 8.88v2M5 9.88h14M9 2.87l2 2 4-4"/></g>'
  }
})
